// @ts-strict-ignore
import React from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { SearchMenu } from 'components/Search/SearchMenu';

const SearchMenuContainer = styled(Box)`
  @media print {
    display: none;
  }
`;

type Props = {
  height?: string | number;
  onSearch?: () => void;
  searchMode: boolean;
  navSection: 'MAIN' | 'STAFF' | undefined;
  defaultSearchType: DefaultSearchType | undefined;
};

export function LayoutSearchMenu({
  height,
  onSearch,
  searchMode,
  navSection,
  defaultSearchType,
}: Props) {
  const search = () => {
    if (onSearch) onSearch();
  };

  return (
    <SearchMenuContainer height={height}>
      <SearchMenu
        searchMode={searchMode}
        navSection={navSection}
        onSearch={search}
        defaultSearchType={defaultSearchType}
        searchFrom="Header Search Bar"
        inPageHeader
      />
    </SearchMenuContainer>
  );
}
